
import { Badge } from "@/components/ui/badge";
import { Calendar, CheckCircle2, Users } from "lucide-react";

const ReferralMilestones = () => {
  return (
    <div className="p-5 bg-gray-50 rounded-lg text-center border border-gray-100">
      <p className="font-medium text-sm text-[#4A607B] mb-3">
        Invite friends who subscribe to unlock rewards:
      </p>
      <div className="flex flex-col gap-3">
        <div className="inline-flex items-center px-4 py-3 bg-white rounded-lg shadow-sm">
          <Badge variant="outline" className="bg-green-100 text-green-800 mr-2 border-green-200">10</Badge>
          <Calendar className="h-4 w-4 mr-1.5 text-green-600" />
          <span className="font-medium text-green-700">Free Month of Premium</span>
          <CheckCircle2 className="h-4 w-4 ml-2 text-green-500" />
        </div>
        
        <div className="text-xs text-gray-500 mt-1">
          <Users className="h-3 w-3 inline mr-1 text-gray-400" />
          <span>Your referrals will inherit your affiliate benefits!</span>
        </div>
      </div>
    </div>
  );
};

export default ReferralMilestones;
